import React, { Fragment } from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'

import postStyles from './post.module.css'

export function PostLink({ post, trending, description }) {
    const title = post.title || post.slug

    const styles = () => {
        if (trending) {
            return postStyles.postcolumn
        } else {
            return postStyles.post
        }
    }

    const imageSrc = post.image

    return (
        <Link
            to={`/${post.slug}` || post.slug}
            key={post.id}
            className={styles()}
        >
            <img
                src={
                    imageSrc === null
                        ? 'https://images.pexels.com/photos/5123471/pexels-photo-5123471.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
                        : imageSrc.url
                }
                alt="Girl in a jacket"
                className={postStyles.image}
            ></img>

            {description(title, post.createdAt)}
        </Link>
    )
}

const Posts = ({ pageTitle, sliceValue, category, trending, grid, button, customPost }) => {
    const { gcms } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                    }
                }
                gcms {
                    posts(orderBy: publishedAt_DESC) {
                        id
                        createdAt
                        title
                        category
                        image {
                            url
                        }
                        slug
                        body {
                            html
                        }
                    }
                }
            }
        `
    )

    const posts = gcms.posts
    let allPosts = sliceValue ? posts.slice(0, sliceValue) : posts
    allPosts = customPost ? customPost : allPosts

    const getDate = datetocalc => {
        const today = new Date()
        let todayDate =
            today.getFullYear() +
            `${today.getMonth() + 1}` +
            `0${today.getDate()}`

        const createdAt = datetocalc.slice(0, 10).replace(/-/g, '')

        if(todayDate.length === 9) {
            todayDate = todayDate.replaceAt(6, '');
        }

        const fromToday = parseInt(todayDate) - parseInt(createdAt)

        return {
            fromToday
        }
    }

    String.prototype.replaceAt = function(index, replacement) {
        if (index >= this.length) {
            return this.valueOf();
        }
    
        return this.substring(0, index) + replacement + this.substring(index + 1);
    }

    const description = (whatever, date) => {
        const description = whatever.length < 44 ? whatever : `${whatever}`
        // const description = whatever.length < 44 ? whatever : `${whatever.substring(0, 50)}...`

        if (category) {
            return (
                <div className={postStyles.description}>
                    <p className={postStyles.title}>{description}</p>
                    <p className={postStyles.date}>
                        {getDate(date).fromToday === 0
                            ? 'Today'
                            : `${getDate(date).fromToday} DAYS AGO`}
                    </p>
                </div>
            )
        } else {
            return (
                <div className={postStyles.description}>
                    <p>{description}</p>
                </div>
            )
        }
    }

    return (
        <Fragment>
            {pageTitle ? (
                <h2 className={postStyles.header}>{pageTitle}</h2>
            ) : (
                ''
            )}

            <div className={grid ? postStyles.postsgrid : postStyles.posts}>
                {allPosts?.map(post => {
                    let filter

                    if (category) {
                        category.map(value => {
                            if (post.category.includes(value)) {
                                filter = true
                            }

                            return filter
                        })

                        if (filter) {
                            return (
                                <PostLink
                                    post={post}
                                    trending={trending}
                                    description={description}
                                />
                            )
                        }
                    } else {
                        return (
                            <PostLink
                                post={post}
                                trending={trending}
                                description={description}
                            />
                        )
                    }
                })}
            </div>

            {button ? (
                <Link to="news" className={postStyles.moreBtn}>
                    Load More
                </Link>
            ) : (
                ''
            )}
        </Fragment>
    )
}

export default Posts
